'use client';

import {Ref, useRef} from 'react';

export function useForwardingRef<T extends HTMLElement>(inputRef: Ref<T> = null) {
	const ref = useRef<T>(null);

	if (inputRef === null) {
		return ref;
	}

	if (typeof inputRef === 'function') {
		inputRef(ref.current);
		return ref;
	}

	return inputRef;
}
